export default __webpack_public_path__ + "static/media/dynamic-close-icon.0d7580a2.svg";